"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateDeliveryEvent = exports.Name = void 0;
const Name = exports.Name = 'update-delivery';
const UpdateDeliveryEvent = exports.UpdateDeliveryEvent = Name;
//# sourceMappingURL=index.js.map